import { render, staticRenderFns } from "./arch.vue?vue&type=template&id=99905ace&"
import script from "./arch.vue?vue&type=script&lang=js&"
export * from "./arch.vue?vue&type=script&lang=js&"
import style0 from "./arch.vue?vue&type=style&index=0&id=99905ace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports